/** ESCHER FALLS — Español (Latinoamérica)。メキシコ・中南米向け。 */

import type { Strings } from './ja';

export const ES: Strings = {
  pour: 'Soltar',
  lever: 'Palanca',
  leverAria: 'Accionar la palanca',
  retry: 'Reiniciar',
  again: 'Otra vez',
  next: 'Siguiente',
  share: 'Compartir esta imagen',
  shareFailed: 'No se pudo compartir',
  rotateLeft: 'Girar la vista a la izquierda',
  rotateRight: 'Girar la vista a la derecha',
  tiltUp: 'Subir la vista',
  tiltDown: 'Bajar la vista',
  topDown: 'Desde arriba',
  water: (left, total) => `Agua ${left} / ${total}`,
  moves: (left, total) => `Giros ${left} / ${total}`,
  timeLeft: (time) => `Quedan ${time}`,
  drops: (n) => `${n} gotas`,

  resultClear: 'Corrió',
  resultFail: 'No corrió',
  clearTitle: 'Corrió el agua',
  fail: {
    time: 'Se acabó el tiempo',
    moves: 'No quedan giros',
    drywell: 'El agua cayó en el pozo seco',
    water: 'Se acabó el agua',
    deadend: 'El agua cayó en un tramo sin salida',
  },
  extendByAd: 'Ver un anuncio por 30 segundos más',
  extendByDrops: (cost) => `${cost} gotas por 30 segundos más`,
  multiplyByAd: (mult) => `Ver un anuncio por ×${mult} gotas`,

  stages: 'Niveles',
  settingsAria: 'Ajustes',
  menuAria: 'Menú',
  back: 'Volver',
  loop1: 'Primera vuelta',
  loop2: 'Segunda vuelta',
  loopNote: 'La segunda vuelta aprieta los giros y el tiempo. Sus registros se guardan aparte.',
  shop: 'Tienda',
  groupMain: 'Principal',
  groupExtra1: 'Extras',
  groupExtra2: 'Extras II',
  freeTrial: 'Gratis',
  notPurchased: (n, name) => `${n} ${name} (bloqueado)`,
  lockedStage: 'Nivel bloqueado',
  extraLockedFree: 'El nivel 1, «La cascada al revés», es gratis. Los demás se abren al comprar desde Ajustes (≡).',
  extraLocked: 'Se abre al comprar desde Ajustes (≡).',
  extra2Locked: 'Del nivel 11 en adelante se abren cuando el agua haya corrido en los niveles 1–10.',
  extra2LockedUnowned: 'Compra desde Ajustes (≡) y completa los niveles 1–10 para abrir del 11 en adelante.',
  extra2Note: 'Se abre cuando el agua haya corrido en todos los Extras.',
  progress: (cleared, total) => `Principal ${cleared} / ${total} completados`,
  totalTime: (time) => `Total ${time}`,
  totalNone: 'Total —',

  settings: 'Ajustes',
  bgm: 'Ambiente',
  se: 'Efectos',
  testSound: 'Probar el sonido',
  audioStatus: (state) => `Sonido: ${state}`,
  audioState: {
    locked: 'Bloqueado (toca la pantalla una vez para activarlo)',
    running: 'Activo',
    suspended: 'En pausa',
  },
  demoNote: (n) => `Estos ${n} niveles son la demo web. Los 42 están en la app.`,
  demoGet: 'Descargar en App Store',
  // — 今日の一面（日替わり）
  dailyTitle: 'Nivel del día',
  dailyLoading: 'Cargando…',
  dailyOffline: 'Sin conexión: el nivel del día no puede abrirse',
  dailyPlay: 'Jugar',
  dailyCleared: (time: string) => `Completado en ${time}`,
  archiveTitle: 'Niveles anteriores',
  upcomingTitle: 'Niveles próximos',
  archiveLocked: 'Los últimos 3 días son gratis. Compra los Extras para abrir todos los anteriores',
  language: 'Idioma',
  languageAuto: 'Seguir el dispositivo',
  palette: 'Paleta',
  worn: 'En uso',
  owned: 'Adquirida',
  buyDrops: 'Comprar gotas',
  restore: 'Restaurar compras',
  writeReview: 'Calificar esta app',
  moreApps: 'Más del mismo autor',
  restoreChecking: 'Comprobando…',
  restoreDone: (n) => `Se restauraron ${n}`,
  restoreNone: 'No hay nada que restaurar',
  restoreFailed: 'No se pudo restaurar',
  chooseStage: 'Elegir un nivel',
  resume: 'Continuar',

  prizeLabel: 'Recompensa',
  awardLabel: 'Título',
  toExtra: 'A los Extras',
  toLoop2: 'A la segunda vuelta',
  toStart: 'Al inicio',
  allClearTitle: 'Recorrido',
  allClearBody: (n) => `El agua ha corrido por los ${n} canales`,
  multiplyTimes: (mult) => `Ver un anuncio por ×${mult}`,
  noteRank: 'El título queda en el registro y se muestra sobre la lista de niveles.',
  noteLoop2: 'La segunda vuelta está abierta. Los giros y el tiempo aprietan más.',
  notePartOne: 'Hasta aquí la Parte Uno. El agua todavía no ha subido.',
  inviteTry: 'Probar el Extra 1',
  inviteOpen: 'Abrir Extras I — 20 niveles',
  dateLine: (d) =>
    `${d.getDate()} de ${['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'][d.getMonth()]} de ${d.getFullYear()}`,

  completionTitle: 'Quien cruzó lo infinito',
  rank: {
    none: '—',
    sovereign: 'Soberano del agua',
    architect: 'Arquitecto de cascadas',
    mason: 'Cantero',
    apprentice: 'Aprendiz',
    wayfarer: 'Caminante',
  },

  skin: {
    hakushi: 'Papel en blanco',
    ai: 'Añil',
    koke: 'Musgo',
    shu: 'Bermellón',
    sumi: 'Tinta sumi',
  },

  product: {
    drops600: '600 gotas',
    drops1600: '1,600 gotas',
    drops5000: '5,000 gotas',
    noads: 'Quitar los anuncios',
    extras: 'Extras I — 21 niveles (sin anuncios)',
  },
};
